"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatelessControls = void 0;
class StatelessControls {
    /**
     * A mapping of step IDs to their corresponding data.
     * Built for stateless triggering by the local studio, those values will not be persisted outside of the job scope
     * First key is step id, second is controlId, value is the control value
     * @type {Record<stepId, Data>}
     * @optional
     */
    steps;
}
exports.StatelessControls = StatelessControls;
//# sourceMappingURL=stateless-controls.js.map